import { useEffect } from 'react';
import { usePortalAuth } from '../context/PortalAuthContext';
import { applyLanguage } from '.';

export default function LanguageSync() {
  const { account } = usePortalAuth();
  const language = account?.customerLanguage || account?.locale;

  useEffect(() => {
    if (language) applyLanguage(language);
  }, [language]);

  return null;
}
